/**
 *  @author => @RMT_FRONT_CORE/CLI
 * */
import React from 'react';
import settings from 'config/constants';

const GRMTAlertMonitor = React.lazy(() => import('./views/pages/AlertMonitorPage'));

const subUrl = settings.PRODUCTS.GRMT.path;
const modulePath = `${subUrl}/alert-monitor`;

type Route = {
    path: string,
    name: string,
    exact: boolean,
    page: Function,
    subRoutes?: Array<Route>,
}

const ROUTES: Array<Route> = [
    { path: `/${modulePath}`, name: 'Alert Monitor', exact: true, page: GRMTAlertMonitor }
];

export default ROUTES;
